import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';

// Components
import JcPortalSalesOrderHQTable from "./JcPortalSalesOrderHQTable";
import JcOnlineShopPaymentTable from "./JcOnlineShopPaymentTable";

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import {PDFDownloadLink} from '@react-pdf/renderer';
import {JcOnlineOrderPdf} from "../../../components/PDF/JcOnlineOrderPdf";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
import LoadingModal from "../../../components/Modal/LoadingModal";
//cookies
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #59b259",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#c1c3d8",
		display:"none"
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(89, 178, 89, 0.09)",
		padding: "1rem",
		border: "1.5px solid #59b259",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	wayBillbuttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
		marginTop:"1rem !important",
		marginRight:"1rem !important",
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #59b259",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const JcOnlineShopOrdersView = () => {
	const { drno, flag} = useParams();
	const [soInfo, setSoInfo] = useState(null);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in item table
	const [payments, setPayments] = useState([]); //data to display in item table
	const [showPDF, setShowPdf] = useState(false);

	const [shipping, setShipping] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const [shippingId, setShippingId] = useState('');
	const [shippingName, setShippingName] = useState('');
	const [warehouseId, setWarehouseId] = useState('');
	const [refno, setRefno] = useState('');
	let history = useHistory();

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF	
	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);	
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const selectShippingProps = {
		options: shipping,
		getOptionLabel: (option) => option.description,
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: (option) => option.description,
	};

	useEffect(() => {
		if(shippingId&&warehouseId&&refno&&soInfo){
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [refno,shippingId,warehouseId,soInfo]);

	const data = async () => {
		await axios.get(process.env.REACT_APP_API_URL+'jconlineshop_view', {
			params:{
				drno: drno,
				jc_u_idno: get_cookies('branchidno')
			}
		}).then((res)=>{
			setItems(res.data.data.order_items);
			setSoInfo(res.data.data.order_details);
			setShipping(res.data.data.get_shipping);
			setWarehouse(res.data.data.warehouses);
			setPayments(res.data.data.customer_alloc);
			if(res.data.data.order_details){
				setShowPdf(true);
			}
			//total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
		}).catch((error)=>{
		//console.log(error.message);
		})
	};	


	const release_online_orders = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true); //show loading/please wait modal
		const formData = new FormData();
		// drno:8992
		// locid:8
		// shipid:1
		// shipping_name:TOKTOK
		// refnum:8ty87t8976tg8gh87u
		// totalamt:595
		//jc_u_idno:DAVAOHQ
		formData.append("drno", drno);
		formData.append("locid", warehouseId);
		formData.append("shipid", shippingId);
		formData.append("shipping_name", shippingName);
		formData.append("refnum", refno);
		formData.append("totalamt", soInfo.totalamt);
		formData.append("jc_u_idno", get_cookies('branchidno'));
		
		await axios.post(process.env.REACT_APP_API_URL+'release_sales_order_process', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Successfully Released Sales Order #"+drno);
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/sales/jconlineshop');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	
	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				{/* <img src={logo} width="100" height="50" alt="jc logo"/> */}
				<NavLink to={"/sales"}><h4 style={{color:"#339933"}}>Sales</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<NavLink to={"/sales/jconlineshop"}><h4 style={{color:"#339933"}}>Jc Dropshipping Orders</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Online Sales Order #{drno}</h4>
			</div>
			{soInfo ? (			<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<LoadingModal showModal={showModal}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
								Online Sales Order View
								</div>
								<div className={classes.title}>
								Online Sales Order View
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						{soInfo ? (<Grid container spacing={3}>
							<Grid item xs={12} sm={12} md={12} lg={5} >
							<div className={classes.infoContainer}>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Delivery To
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{/* blank */}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Customer:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.customer_name || "customer_name"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Address:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.customer_address || "Contact Number"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
										Contact No:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.mobile_no}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4}className={classes.infoTitle}>
									Email:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.email || "Total"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Classification:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.transaction_type || "Total"}
									</Grid>
								</Grid>
								<Grid container spacing={3}>
									<Grid item xs={12} sm={4} className={classes.infoTitle}>
									Shipping:
									</Grid>
									<Grid
										item
										xs={12} sm={8}
										className={classes.infoContent}
									>
										{soInfo.shipping || "Total"}
									</Grid>
								</Grid>
							   </div>
							</Grid>
							
							<Grid item xs={12} sm={12} lg={7}>
								{/* payment table */}
								<JcOnlineShopPaymentTable items={payments}/>	
								{/* <JcPortalSalesOrderHQTable items={items}/>	 */}
							</Grid>
						</Grid>) : (<></>)}



						<h4>Item Details</h4>
						<JcPortalSalesOrderHQTable items={items}/>	

						{soInfo ? (<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div className={classes.infoTotalItem}>
										<LocalShippingTwoToneIcon
											className={classes.infoTotalIcon}
										/>
										{"Shipping: "+ numeral(soInfo.freight).format('0,0.00')}							
								</div>
								<div className={classes.infoTotalItem}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "+ numeral(soInfo.totalamt).format('0,0.00')}
								</div>	
							</div>
						</div>) : (<></>)}

						{flag=="release" ? (<Grid container spacing={1}>
							<Grid item xs={12} lg={6}>
								<Autocomplete
											{...selectLocationProps}
											id="auto-complete-2"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													margin="normal"
													label="Warehouse Location"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setWarehouseId(newValue.id);
												}
											}}
								/>
							</Grid>
							<Grid item xs={12} lg={6}>
								<Autocomplete
										{...selectShippingProps}
											style={{marginTop:"1rem"}}
											id="auto-complete-1"
											autoComplete
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													label="Shipping"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setShippingId(newValue.id);
													setShippingName(newValue.description);
												}
											}}
								/>
							</Grid>
							<Grid item xs={12} lg={6}>
									<TextField
													id="outlined-required"
													style={{marginTop:"1rem"}}
													label="Shipping Ref Number"
													variant="outlined"
													placeholder="For pickup orders, enter 'NA'."
													fullWidth={true}
													className={classes.field}
													value={refno} 
													onChange={(e)=>{setRefno(e.target.value)}}
													InputProps={{
														type: 'text',
													  }}
										/>				
							</Grid>
						</Grid>) : (<></>)}

						{soInfo ? (<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={soInfo.notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>) :(<></>)}
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={12} lg={12}>
							{showPDF && <PDFDownloadLink
											document={<JcOnlineOrderPdf soInfo={soInfo} items={items} payments={payments}/>}
											fileName={"JcOnlineOrderPdf#"+drno+".pdf"}
											style={{
												textDecoration: "none",
												padding: "6px 8px 10px",
												color: "#fff",
												display:"inline-block",
												marginBottom:"7px",
												fontFamily: "Ubuntu",
												backgroundColor: "#339933",
												border: "1px solid #339933",
												borderRadius: "4px"
												}}
										    >
											{({ blob, url, loading, error }) =>
											loading ? "Loading document..." : "Print DR"
											}
							</PDFDownloadLink>}
							{flag=="release" ? (<Button  disabled={btnDisabled} onClick={()=>{release_online_orders()}} variant="contained" color="primary">Release Sales Order</Button>) : (<></>)}
						</Grid>
						</Grid>
					</div>
			</div>
		) : (<Preloader />)}
		</div>
	);
};

export default JcOnlineShopOrdersView;
